import { Box, Grid } from '@mui/material'
import CustomButton from 'components/Fileds/CustomButton'
import CustomSearch from 'components/Fileds/CustomSearch'
import ItemCard from 'components/ItemCard/ItemCard'
import ItemCardSkeleton from 'components/ItemCard/ItemCardSkeleton'
import AddMiscItemModal from 'components/Modal/AddMiscItem/AddMiscItemModal'
import AddOnsCofirmation from 'components/Modal/AddOnsDialog/AddOnsCofirmation'
import AddOnsDialog from 'components/Modal/AddOnsDialog/AddOnsDialog'
import UpdateQunatity from 'components/Modal/AddOnsDialog/UpdateQunatity'
import NoItemsCreated from 'components/NoItemsCreated/NoItemsCreated'
import NoSearchFound from 'components/NoSearchFound/NoSearchFound'
import { Add } from '@mui/icons-material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const MenuItemCardListContainer = ({
  handleAddClick,
  handleCloseAddOnsDialog,
  userData,
  theme,
  addOnsDialogOpen,
  selectedItem,
  items,
  searchQuery,
  onSearchChange,
  orderType,
  removeItemFromOrder,
  getItemQuantity,
  isLoading,
  filteredItems,

  confirmDialogOpen,
  handleCloseConfirmation,
  handleAddNew,
  handleRepeatLast,
  itemForConfirmation,
  getTotalQuantityById,

  updateDialogOpen, updateDialogItem, updateItemSelections, closeUpdateDialog, showAddNew,

  miscDialogOpen,
  handleOpenMiscDialog,
  handleCloseMiscDialog,
  handleSaveMiscItem,
}) => {
  const navigate = useNavigate()
  const isSearching = Boolean(searchQuery && searchQuery.trim().length > 0)
  const hasNoItems = !items || items.length === 0
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 3,
          justifyContent: "space-between",
          flexWrap: { xs: "wrap", sm: "nowrap" },
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0, maxWidth: orderType ? { xs: "100%", sm: "calc(100% - 200px)" } : "100%", }}>
          <CustomSearch
            onSearchChange={onSearchChange}
            searchQuery={searchQuery}
            placeholder={"Search with Item Name here..."}
            isLoading={false}
          />
        </Box>
        {orderType &&
          <CustomButton
            variant="contained"
            size={"medium"}
            onClick={handleOpenMiscDialog}
            sx={{
              borderRadius: "10px",
              width: { xs: "100%", sm: "180px" },
              flexShrink: 0,
              textTransform: "none",
              ml: { xs: 0, sm: "auto" },
            }}
          >
            Add Misc.
          </CustomButton>
        }
      </Box>
      {isLoading ? (
        // Skeleton loading state
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          {[...Array(8)]?.map((_, index) => (
            <Grid item xs={6} sm={4} md={3} key={`skeleton-${index}`}>
              <ItemCardSkeleton orderType={orderType} />
            </Grid>
          ))}
        </Grid>
      ) : filteredItems.length === 0 ? (
        <Box sx={{ mt: 4, mb: 4, display: 'flex', justifyContent: 'center' }}>
          {isSearching && !hasNoItems ? (
            <NoSearchFound
              title="No Food Item matches your search"
              subtitle="Please try again with a different keyword to get results."
              width="240px"
              height="240px"
            />
          ) : (
            <NoItemsCreated
              title="No Food Items Created Yet!"
              subtitle="Add your first food item to create your menu and start taking orders."
              width="240px"
              height="240px"
            >
              <CustomButton
                variant="contained"
                onClick={() => navigate('/food-items/manage-food-items')}
                startIcon={<Add />}
                sx={{
                  mt: 2,
                  borderRadius: "10px",
                  px: 3,
                  height: "42px",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "14px",
                  backgroundColor: "#111111",
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "#222222",
                  },
                }}
              >
                Add Food Items
              </CustomButton>
            </NoItemsCreated>
          )}
        </Box>
      ) : (
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          {filteredItems.map((item) => {
            // const itemQuantity = getItemQuantity(item)
            const itemQuantity = getTotalQuantityById(item.id)
            return (
              <Grid className='menu-item-card-listing' item xs={6} sm={4} md={3} key={item.id}>
                <ItemCard
                  item={item}
                  itemQuantity={itemQuantity}
                  orderType={orderType}
                  handleAddClick={handleAddClick}
                  removeItemFromOrder={removeItemFromOrder}
                  theme={theme}
                  userData={userData}
                />
              </Grid>
            )
          })}
        </Grid>
      )}

      {/* Add-Ons Dialog */}
      <AddOnsDialog open={addOnsDialogOpen} onClose={handleCloseAddOnsDialog} item={selectedItem} />

      <AddOnsCofirmation
        open={confirmDialogOpen}
        onClose={handleCloseConfirmation}
        item={itemForConfirmation}
        onAddNew={handleAddNew}
        onRepeatLast={handleRepeatLast}
      />

      {updateDialogItem && (
        <UpdateQunatity
          open={updateDialogOpen}
          item={{
            name: updateDialogItem.name,
            addOnSelections: updateDialogItem.variants
          }}
          onClose={closeUpdateDialog}
          onSave={updateItemSelections}
          onAddNew={handleAddNew}
          showAddNew={showAddNew}
        />
      )}

      <AddMiscItemModal
        open={miscDialogOpen}
        onClose={handleCloseMiscDialog}
        onSubmit={handleSaveMiscItem}
      />
    </Box>
  )
}

export default MenuItemCardListContainer
